/// <reference path="../../../../core/web/site/embedded/script/core.js" />
if (!rtAPI) var rtAPI = {};

//#region Init

rtAPI.loadingPanel = {
    'active': true,
    'useIcon': true,
    'text': 'Loading. Please wait......',
    'icon': '<div class="profile-main-loader"><div class="loader"><svg class="circular-loader" viewBox="25 25 50 50"><circle class="loader-path" cx="50" cy="50" r="20" fill="none" stroke="#333333" stroke-width="4" /></svg></div></div>'
};

//#endregion

//#region Visibility

rtAPI.loadingPanel.show = function () {
    if (!this.active) return;
    this.getDiv().style.display = "flex";
    document.body.classList.add("postback-lock");
}

rtAPI.loadingPanel.hide = function () {
    if (!this.active) return;
    this.getDiv().style.display = "none";
    document.body.classList.remove("postback-lock");
}

//#endregion

//#region Render

rtAPI.loadingPanel.getDiv = function () {
    var loadingPanelDiv = document.getElementById('postback-content-overlay');
    if (!loadingPanelDiv) {
        loadingPanelDiv = document.createElement("div");
        loadingPanelDiv.id = 'postback-content-overlay';
        loadingPanelDiv.className = 'rt-postback-content-overlay';
        loadingPanelDiv.style.display = 'none';
        document.body.insertBefore(loadingPanelDiv, document.body.firstChild);

        loadingPanelDivContent = document.createElement("div");
        if (this.useIcon) {
            loadingPanelDivContent.innerHTML = this.icon
            loadingPanelDivContent.className = 'rt-postback-content-overlay-message icon';
        }
        else {
            loadingPanelDivContent.innerHTML = this.text
            loadingPanelDivContent.className = 'rt-postback-content-overlay-message';
        };
        loadingPanelDiv.appendChild(loadingPanelDivContent);
    }
    return loadingPanelDiv
}

//#endregion

